/**
 * The slice of the Web Storage API the hooks keep their lists through, and
 * `localStorage` behind it. Touching `window.localStorage` can itself throw
 * where site data is blocked, so it happens inside the caller's own try/catch.
 */
export interface KeyValueStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

export const deviceStorage: KeyValueStorage = {
  getItem: (key) => localStorage.getItem(key),
  setItem: (key, value) => localStorage.setItem(key, value),
  removeItem: (key) => localStorage.removeItem(key),
};
